module.exports = __webpack_public_path__ + "static/media/angry_bee_mirror.9ec4af77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bee/angry_bee_mirror.png
// module id = 161
// module chunks = 0